import { createPortal } from 'react-dom';
import { Spinner } from './Spinner';

export const FullscreenLoader = () => {
  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/60 backdrop-blur-sm">
      <Spinner />
    </div>,
    document.body
  );
};
